// Manufacturer Status Options
export const MANUFACTURER_STATUS_OPTIONS = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Inactive', value: 'INACTIVE' },
] as const;

// Status Filter Options
export const STATUS_FILTER_OPTIONS = MANUFACTURER_STATUS_OPTIONS;

// Status Colors
export const STATUS_COLORS = {
    ACTIVE: 'green',
    INACTIVE: 'red',
} as const;

// Status Icons
export const STATUS_ICONS = {
    ACTIVE: '✓',
    INACTIVE: '✗',
} as const;
